var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMostlycloudy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 68h39a14 14 0 0 0 0-28 21 21 0 0 0-39-7A18 18 0 0 0 20 68z",
    fill: "#edf4f8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 77h37a13 13 0 0 0 0-26 20 20 0 0 0-37-6A16 16 0 0 0 35 77z",
    fill: "#b9c9d6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#7d95a7",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 68h39a14 14 0 0 0 0-28 21 21 0 0 0-39-7A18 18 0 0 0 20 68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 77h37a13 13 0 0 0 0-26 20 20 0 0 0-37-6A16 16 0 0 0 35 77z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostlycloudy);
export default __webpack_public_path__ + "static/media/mostlycloudy.0455253524a974e504283a2015eb2920.svg";
export { ForwardRef as ReactComponent };